import React from "react";
import Loader from "../Common/Loader";

function VendorDepositsAndActivations({activations, loading8, loading9}) {
    return (
        <>
            <div className="border-top mt-1"></div>
            <div className="table-responsive">
                {loading8 || loading9 ? (
                    <Loader /> 
                ) : (
                    <table className="table display data-table text-nowrap">
                        <thead>
                            <tr>
                                <th>Transaction Date</th>
                                <th>Student Name</th>
                                <th>School</th>
                                <th>Transaction Details</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {activations.length > 0 ? (
                                activations.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.date?.short_date}<br /><small>{item.date?.time}</small></td>                                          
                                    <td>{item.student_name}<br/><small>{item.group}</small></td>
                                    <td>{item.school}</td>
                                    <td>{item.activity}</td>

                                </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No deposits or activations yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        
        </>
        
    );
}

export default VendorDepositsAndActivations;
